/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { useGlobalContext } from '../../context/GlobalContext';
import { API_URL } from '../../../actions';
import { resourceCompanies } from '../../../utils/resourceCompanies';

import SelectMedia from '../medias/SelectMedia';
import Modale from '../../partials/Modale';
import RemoveModale from '../../partials/RemoveModale/RemoveModale';
import PromptRouter from '../../partials/PromptRouter';
import MetaSeo from '../../partials/MetaSeo';
import ResourceFileForm from './ResourceFileForm';

import { getMediasAction, getResourceFilesAction, postMediaAction, deleteMedia } from '../../../actions/mediasActions';
import { getCompanyAction } from '../../../actions/companiesActions';
import { getPageAction, updatePageAction } from '../../../actions/themeActions';

import '../../../styles/pages-sites.scss';
import './resources.scss';

export default function Resources({
  setDisplayNavBar,
  setDisplaySelectLang,
  setDisplaySiteNav,
  setActivePage,
  theme,
  lang,
}) {
  const param = useParams();
  const page = 'resource';
  const { handleSubmit } = useForm();
  const [context, dispatch] = useGlobalContext();

  const [resource, setResource] = useState();
  const [isMounted, setIsMounted] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [publishIsLoading, setPublishIsLoading] = useState(false);
  const [removeAction, setRemoveAction] = useState();

  const [displaySelectMedia, setDisplaySelectMedia] = useState(false);
  const [selectedMediaList, setSelectedMediaList] = useState([]);
  const [mediaIsMulti, setMediaIsMulti] = useState(false);
  const [mediaType, setMediaType] = useState('image');
  const [mediaKey, setMediaKey] = useState('cover');

  const [pressFiles, setPressFiles] = useState([]);
  const [commercialFiles, setCommercialFiles] = useState([]);
  const [pressReleaseFiles, setPressReleaseFiles] = useState([]);
  const [addCommercialOpen, setAddCommercialOpen] = useState(false);
  const [addPressReleaseOpen, setAddPressReleaseOpen] = useState(false);

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch, param.companyId);
    getMediasAction(dispatch, param.companyId);
  }, [dispatch, param.companyId]);

  const loadResourceFiles = useCallback(async () => {
    const [press, commercial, pressRelease] = await Promise.all([
      getResourceFilesAction(dispatch, 'press'),
      getResourceFilesAction(dispatch, 'commercial'),
      getResourceFilesAction(dispatch, 'pressRelease'),
    ]);
    setPressFiles(press);
    setCommercialFiles(commercial);
    setPressReleaseFiles(pressRelease);
  }, [dispatch]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true);
    setActivePage('ressources');
    getCompany();
    loadResourceFiles();
    return () => {
      setDisplaySelectLang(false);
      setResource();
      setIsMounted(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getPageAction(dispatch, param.companyId, page, lang);
    setResource();
    setIsMounted(false);
    dispatch({ type: 'RESET_PAGE' });
    // eslint-disable-next-line
  }, [lang]);

  useEffect(() => {
    if (context.theme.page) {
      setResource({
        titleIsWhite: true,
        pressContact: {},
        ...context.theme.page,
        pressContact: {
          intro: '',
          name: '',
          company: '',
          role: '',
          email: '',
          ...(context.theme.page.pressContact || {}),
        },
      });
      setIsMounted(true);
    } else {
      setResource();
      setIsMounted(false);
    }
    dispatch({ type: 'MESSAGE_PAGE', payload: null });
    // eslint-disable-next-line
  }, [context.theme.page]);

  useEffect(() => {
    if (resource && context.theme.page) {
      setIsSaved(JSON.stringify(resource) === JSON.stringify({
        titleIsWhite: true,
        pressContact: {},
        ...context.theme.page,
        pressContact: {
          intro: '',
          name: '',
          company: '',
          role: '',
          email: '',
          ...(context.theme.page.pressContact || {}),
        },
      }));
    }
    // eslint-disable-next-line
  }, [resource]);

  useEffect(() => {
    if (context.theme?.message === 'Theme successfully updated') {
      setPublishIsLoading(false);
      dispatch({ type: 'MESSAGE_PAGE', payload: null });
      dispatch({
        type: 'SET_TOAST',
        payload: { message: 'La page a bien été enregistrée', type: 'success' },
      });
    }
    // eslint-disable-next-line
  }, [context.theme.message]);

  function submitMedia(value) {
    if (mediaKey === 'cover') {
      setResource({ ...resource, cover: value[0] });
    }
  }

  function openSelectCover() {
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('cover');
    setMediaType('image');
    if (resource?.cover) {
      setSelectedMediaList([resource.cover._id || resource.cover]);
    } else {
      setSelectedMediaList([]);
    }
  }

  function renderCoverImg() {
    if (resource?.cover) {
      if (resource.cover.path) {
        return <img src={`${API_URL}/${resource.cover.path}`} alt="cover" />;
      }
      const imgFound = context.medias.mediasList?.find((item) => item._id === resource.cover);
      if (imgFound) {
        return <img src={`${API_URL}/${imgFound.path}`} alt="cover" />;
      }
    }
    return null;
  }

  function getPressFileForCompany(companyId) {
    return pressFiles.find((file) => {
      const fileCompany = file.company?._id || file.company;
      return String(fileCompany) === String(companyId);
    });
  }

  async function uploadPressKit(companyId, event) {
    const input = event.currentTarget;
    const file = input.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      dispatch({
        type: 'SET_TOAST',
        payload: { message: 'Seuls les fichiers PDF sont autorisés', type: 'error' },
      });
      input.value = '';
      return;
    }

    const existing = getPressFileForCompany(companyId);
    if (existing) {
      await deleteMedia(dispatch, existing._id, companyId);
    }

    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('company', companyId);
    formData.append('title', `Kit presse ${resourceCompanies.find((c) => c.companyId === companyId)?.name || ''}`);
    formData.append('description', '');
    formData.append('alt', 'Kit presse');
    formData.append('type', 'press');
    formData.append('isThumbnail', false);
    formData.append('isPriority', false);
    formData.append('langs', 'fr,en,es');

    try {
      await postMediaAction(dispatch, formData);
      await loadResourceFiles();
    } finally {
      input.value = '';
    }
  }

  async function handleDeleteFile(file) {
    const companyId = file.company?._id || file.company;
    await deleteMedia(dispatch, file._id, companyId);
    await loadResourceFiles();
  }

  function updatePressContact(field, value) {
    setResource({
      ...resource,
      pressContact: {
        ...resource.pressContact,
        [field]: value,
      },
    });
  }

  const submitResource = async (values = {}) => {
    setPublishIsLoading(true);
    const resourceData = { ...values, ...resource };
    const obj = {};

    for (const [key, value] of Object.entries(resourceData)) {
      obj[`${page}.${key}`] = value;
    }

    await updatePageAction(dispatch, context.companies.company.theme[lang], 'group', page, obj);
    dispatch({ type: 'ERROR_PAGE', payload: null });
    dispatch({ type: 'MESSAGE_PAGE', payload: null });
  };

  function renderFileRow(file) {
    const thumb = file.thumbnail?.path
      ? `${API_URL}/${file.thumbnail.path}`
      : null;
    const companyName = resourceCompanies.find(
      (c) => c.companyId === String(file.company?._id || file.company)
    )?.name;

    return (
      <div className="resource-file-row" key={file._id}>
        {thumb && <img src={thumb} alt={file.title} className="resource-file-thumb" />}
        <div className="resource-file-info">
          <strong>{file.title}</strong>
          {companyName && <span>{companyName}</span>}
          <span>{file.langs?.join(', ')}</span>
        </div>
        <button
          type="button"
          className="btn primary"
          onClick={() => setRemoveAction({ function: () => handleDeleteFile(file) })}
        >
          Supprimer
        </button>
      </div>
    );
  }

  function renderEdit() {
    return (
      <div className="list-item transition edit-row">
        <form onSubmit={handleSubmit(submitResource)} autoComplete="nope">
          <div className="form-row">
            <div className="col-1">
              <div className="title">
                <h2>En-tête de page</h2>
              </div>

              <label htmlFor="title">Titre de la page</label>
              <input
                name="title"
                value={resource?.title || ''}
                onChange={(e) => setResource({ ...resource, title: e.target.value })}
              />

              <div className="isWhite">
                <input
                  id="isWhite"
                  onChange={() => setResource({ ...resource, titleIsWhite: !resource.titleIsWhite })}
                  type="checkbox"
                  className="switch"
                  checked={!resource?.titleIsWhite}
                />
                <label htmlFor="isWhite">
                  {resource?.titleIsWhite ? <span>Titre en blanc</span> : <span>Titre en noir</span>}
                </label>
              </div>

              <div className="section" />

              <div className="title">
                <h2>Kits presse</h2>
                <p className="note">Un PDF par société (Keran + filiales)</p>
              </div>

              <div className="press-kit-grid">
                {resourceCompanies.map((company) => {
                  const pressFile = getPressFileForCompany(company.companyId);
                  return (
                    <div className="press-kit-item" key={company.companyId}>
                      <strong>{company.name}</strong>
                      {pressFile ? (
                        <span className="status ok">PDF : {pressFile.title}</span>
                      ) : (
                        <span className="status missing">Aucun PDF</span>
                      )}
                      <label className={`btn primary ${theme}-bg`}>
                        {pressFile ? 'Remplacer' : 'Ajouter'}
                        <input
                          type="file"
                          accept="application/pdf"
                          hidden
                          onChange={(e) => uploadPressKit(company.companyId, e)}
                        />
                      </label>
                    </div>
                  );
                })}
              </div>

              <div className="section" />

              <div className="title">
                <h2>Documents commerciaux et institutionnels</h2>
              </div>
              {commercialFiles.map(renderFileRow)}
              <button
                type="button"
                className={`btn btn-doc primary ${theme}-bg`}
                onClick={() => setAddCommercialOpen(true)}
              >
                Ajouter un document
              </button>

              <div className="section" />

              <div className="title">
                <h2>Communiqués de presse</h2>
              </div>
              {pressReleaseFiles.map(renderFileRow)}
              <button
                type="button"
                className={`btn btn-doc primary ${theme}-bg`}
                onClick={() => setAddPressReleaseOpen(true)}
              >
                Ajouter un communiqué
              </button>

              <div className="section" />

              <div className="title">
                <h2>Contact presse</h2>
              </div>

              <label>Texte d&apos;introduction</label>
              <input
                value={resource?.pressContact?.intro || ''}
                onChange={(e) => updatePressContact('intro', e.target.value)}
                placeholder="Pour toute demande, contactez :"
              />

              <label className='label-form'>Nom</label>
              <input
                value={resource?.pressContact?.name || ''}
                onChange={(e) => updatePressContact('name', e.target.value)}
              />

              <label className='label-form'>Société</label>
              <input
                value={resource?.pressContact?.company || ''}
                onChange={(e) => updatePressContact('company', e.target.value)}
              />

              <label className='label-form'>Fonction</label>
              <input
                value={resource?.pressContact?.role || ''}
                onChange={(e) => updatePressContact('role', e.target.value)}
              />

              <label className='label-form'>Email</label>
              <input
                type="email"
                value={resource?.pressContact?.email || ''}
                onChange={(e) => updatePressContact('email', e.target.value)}
              />
            </div>

            <div className="col-2">
              <div className="btn-actions-container">
                {!publishIsLoading && (
                  <button
                    className={`btn primary publish ${theme}-bg`}
                    type="submit"
                  >
                    Publier
                  </button>
                )}
              </div>

              <label>Photo de couverture<span className={`${theme}-color required`}>*</span><br /><span className="note">minimum 1700 x 350 px</span></label>
              {renderCoverImg()}
              <div className="btn-container">
                <button type="button" className={`btn primary ${theme}-bg`} onClick={openSelectCover}>
                  Parcourir
                </button>
                {resource?.cover && (
                  <button
                    type="button"
                    className={`btn primary ${theme}-bg`}
                    onClick={() => setRemoveAction({ function: () => setResource({ ...resource, cover: null }) })}
                  >
                    Supprimer
                  </button>
                )}
              </div>
            </div>
          </div>

          <MetaSeo
            seo={resource?.seo}
            onChange={(seoData) => setResource({ ...resource, seo: seoData })}
            theme={theme}
            companyId={param.companyId}
          />
        </form>

        <SelectMedia
          displaySelectMedia={displaySelectMedia}
          dispatch={dispatch}
          theme={theme}
          context={context}
          mediaType={mediaType}
          selectedMediaList={selectedMediaList}
          companyId={param.companyId}
          isMulti={mediaIsMulti}
          handleChange={(value) => submitMedia(value)}
          setDisplaySelectMedia={setDisplaySelectMedia}
        />
      </div>
    );
  }

  return (
    <>
      <PromptRouter when={!isSaved} />
      <RemoveModale
        removeAction={removeAction}
        text={{
          sentence: 'Voulez-vous vraiment supprimer cet élément ?',
          confirm: 'Confirmer',
          cancel: 'Annuler',
        }}
        setRemoveAction={setRemoveAction}
        theme={theme}
      />

      {addCommercialOpen && (
        <Modale modaleIsOpen={addCommercialOpen} modaleToggle={setAddCommercialOpen} className="add-media-modale">
          <ResourceFileForm
            companyId={param.companyId}
            theme={theme}
            lang={lang}
            fileType="commercial"
            withCompanySelect
            onSaved={() => {
              setAddCommercialOpen(false);
              loadResourceFiles();
            }}
            onCancel={() => setAddCommercialOpen(false)}
          />
        </Modale>
      )}

      {addPressReleaseOpen && (
        <Modale modaleIsOpen={addPressReleaseOpen} modaleToggle={setAddPressReleaseOpen} className="add-media-modale">
          <ResourceFileForm
            companyId={param.companyId}
            theme={theme}
            lang={lang}
            fileType="pressRelease"
            withCompanySelect={false}
            defaultCompanyId={param.companyId}
            onSaved={() => {
              setAddPressReleaseOpen(false);
              loadResourceFiles();
            }}
            onCancel={() => setAddPressReleaseOpen(false)}
          />
        </Modale>
      )}

      {isMounted && resource && (
        <div id="ressources" className={`page-container site ${theme}`}>
          <div className="page-content">
            <div className="title-row space-between">
              <div className="title">
                <h1>
                  Edition de la page Ressources ({lang})
                </h1>
                <div className="bar primary" />
              </div>
            </div>
            <div className="list-container">{renderEdit()}</div>
          </div>
        </div>
      )}
    </>
  );
}
